import { Vector3 } from '@babylonjs/core/Maths/math.vector';
import { IVector3, IGeometryPointFlat } from 'sharedtypes/math';

import { projectInterface } from '../Tool/interface';
import { vector3Json } from '../Content/content';
import { geometryToJson } from '../../Utils/math';

projectInterface.pointofview = {
    name: 'n',
    position: {
        dim: 'p',
        next: vector3Json
    },
    rotation: {
        dim: 'r',
        next: vector3Json
    }
};

/**
 * Used to parameter a step in the story
 */
export class Pointofview {
    /**
     * Name of the point of view
     */
    public name: string;

    /**
     * The position of the point of view in the 3D scene
     */
    public position = Vector3.Zero();

    /**
     * The rotation of the point of view which determine what we see
     */
    public rotation = Vector3.Zero();

    /**
     * @param system System of the 3D scene
     * @param pointofviewOptions Options to be used
     */
    constructor(pointofviewOptions: IGeometryPointFlat) {
        this.name = pointofviewOptions.name;
        this.setPosition(pointofviewOptions.position);
        this.setRotation(pointofviewOptions.rotation);
    }

    /**
     * Set the position of the pointofview
     * @param position New position
     */
    public setPosition(position: IVector3): void {
        this.savePosition(position);
    }

    private savePosition(position: IVector3) {
        const keys = Object.keys(position);
        keys.forEach((key) => {
            this.position[key] = position[key];
        });
    }

    /**
     * Set the rotation of the pointofview
     * @param rotation New rotation
     */
    public setRotation(rotation: IVector3): void {
        this.saveRotation(rotation);
    }

    private saveRotation(rotation: IVector3) {
        const keys = Object.keys(rotation);
        keys.forEach((key) => {
            this.rotation[key] = rotation[key];
        });
    }

    public getOptions(): IGeometryPointFlat {
        return {
            name: this.name,
            ...geometryToJson(this),
        };
    }
}
